import { CreateInstance } from "./config"
const UserEntityRegisterNotTokeAPI = CreateInstance("user-entity-register-not-token")
export default UserEntityRegisterNotTokeAPI
